import { ellipsisApi } from './ellipsisApi';

// Manually injected until the OpenAPI codegen next runs against a build
// that includes UserConsentController.

export interface ConsentRecordDto {
  id: string;
  userId: string;
  decision: 'accepted' | 'declined';
  policyVersion: string;
  decidedAt: string;
  source?: 'banner' | 'preferences' | 'api';
}

export interface PostConsentBody {
  decision: 'accepted' | 'declined';
  policyVersion: string;
  source?: 'banner' | 'preferences' | 'api';
  decidedAt?: string;
}

const consentApi = ellipsisApi.injectEndpoints({
  endpoints: (build) => ({
    getMyConsent: build.query<ConsentRecordDto | null, void>({
      query: () => ({ url: '/users/me/consent' }),
    }),
    postMyConsent: build.mutation<ConsentRecordDto, PostConsentBody>({
      query: (body) => ({
        url: '/users/me/consent',
        method: 'POST',
        body,
      }),
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            consentApi.util.updateQueryData(
              'getMyConsent',
              undefined,
              () => data
            )
          );
        } catch {
          // Cookie is the local source of truth; next app load will re-reconcile.
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetMyConsentQuery, usePostMyConsentMutation } = consentApi;
export { consentApi };
